var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 29.1L19.125 25.8937L13.9594 21L19.125 16.1062L15.8 12.9L7.25 21L15.8 29.1ZM27.2 29.1L35.75 21L27.2 12.9L23.875 16.1062L29.0406 21L23.875 25.8937L27.2 29.1ZM4.875 41.25C3.56875 41.25 2.45052 40.8094 1.52031 39.9281C0.590104 39.0469 0.125 37.9875 0.125 36.75V5.25C0.125 4.0125 0.590104 2.95312 1.52031 2.07187C2.45052 1.19062 3.56875 0.75 4.875 0.75H38.125C39.4312 0.75 40.5495 1.19062 41.4797 2.07187C42.4099 2.95312 42.875 4.0125 42.875 5.25V36.75C42.875 37.9875 42.4099 39.0469 41.4797 39.9281C40.5495 40.8094 39.4312 41.25 38.125 41.25H4.875ZM4.875 36.75H38.125V5.25H4.875V36.75Z",
    fill: "#181E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card3.d99b51927c1e00d19aa73a502faf1e8f.svg";
export { ForwardRef as ReactComponent };